import { Route } from 'kts-platform-frame/routes';

const parentName: string = '/workbench/platform/appStore'; // 路由的跟节点；

Route.addNode(
    parentName,
    { nodeName: '*/platform/appStore/appManage', path: '*/appManage', component: require('./AppManage').default },
    { nodeName: '*/platform/appStore/appManagement', path: '*/appManagement', component: require('./AppManagement').default },
    { nodeName: '*/platform/appStore/appDetail', path: '*/appDetail/:appKey', component: require('./AppDetail').default },
    { nodeName: '*/platform/appStore/appBatchActivated', path: '*/appBatchActivated', component: require('./AppManage/AppBatchActivated').default },
    { nodeName: '*/platform/appStore/appBatchSetPower', path: '*/appBatchSetPower', component: require('./AppManage/AppBatchSetPower').default },
);

export default {
    getChildReact: (index?: string) => {
        return Route.getChildReact(parentName, index);
    },
};

export {
    Switch
} from 'react-router-dom';


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/Modules.Route.tsx